module.exports = __webpack_public_path__ + "media/images/lb/305-1f2b57316a99ca2522d6ef290fad8878.svg";